// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getUpdatedBulkEditPathsDataByPathId from 'redux/modules/bulkEdit/thunks/getUpdatedBulkEditPathsDataByPathId'
import filterAndSortPaths from 'redux/modules/bulkEdit/thunks/filterAndSortPaths'
import { setBulkEditPaths } from 'redux/modules/bulkEdit/actions'
import getPathsIdsToUpdate from './getPathIdsToUpdate'

/**
 * @typedef {Object} callsignCascadeAggregateGroup
 * @property {Array<number>} matchedSegmentEndIds - segment end ids which should be cascaded with the trigger segment end data
 * @property {number} triggeredSegmentEndId - segment end id that was updated and has triggered the callsign cascade.
 */

/**
 * triggers the update for any paths in the bulk edit store whose segment ends were just cascaded.
 * @param {Array<callsignCascadeAggregateGroup>} callsignCascadeData - this comes from Callsign Cascade redux form
*/

const updateBulkEditPathsAfterCallsignCascadeSuccess = callsignCascadeData => async (dispatch, getState) => {
  const bulkEditPaths = getState().bulkEdit.get('bulkEditPaths')

  const pathsIdsToUpdate = getPathsIdsToUpdate(callsignCascadeData, bulkEditPaths)

  const updatedBulkEditPathsData = await dispatch(getUpdatedBulkEditPathsDataByPathId(pathsIdsToUpdate))

  // update bulkEdit redux store with the path data
  dispatch(setBulkEditPaths(updatedBulkEditPathsData))

  // in case these changes have just removed paths from filtered list of visible paths,
  // we need to trigger an update to the visible paths.
  dispatch(filterAndSortPaths())
}

export default updateBulkEditPathsAfterCallsignCascadeSuccess
